import PropTypes from "prop-types";
import React from "react";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomInput";
import { formatDateTime } from "functions/Helper";

export default function View({ terminalFee }) {
  return (
    <GridContainer>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Effective Date"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            value: formatDateTime(new Date(terminalFee.effectiveDate + "Z")),
            disabled: true
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="Look Up Code"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            value: terminalFee.lookUpCode,
            disabled: true
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="IDR"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            value: terminalFee.idr,
            disabled: true
          }}
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <CustomInput
          labelText="SGD"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            value: terminalFee.sgd,
            disabled: true
          }}
        />
      </GridItem>
    </GridContainer>
  );
}

View.propTypes = {
  terminalFee: PropTypes.object
};
